import styled from "styled-components";
import { Dialog as UIDialog, DialogContent as UIContent } from "@evergis/ui";

export const DialogContent = styled(UIContent)`
  flex-direction: column;
  padding: 2.5rem 3.5rem 1.5rem;
  font-size: 0.75rem;
  color: ${({ theme }) => theme.palette.textSecondary};
`;

export const Dialog = styled(UIDialog)`
  max-width: 22.375rem;
`;

export const LayerCopyrightItem = styled.div`
  margin-bottom: 1rem;
`;
